export default __webpack_public_path__ + "static/media/feature_3.0fadb17c.png";